import { render } from "./GestionCatastro.vue?vue&type=template&id=34664ab4&scoped=true"
import script from "./GestionCatastro.vue?vue&type=script&lang=js"
export * from "./GestionCatastro.vue?vue&type=script&lang=js"

import "./GestionCatastro.vue?vue&type=style&index=0&id=34664ab4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34664ab4"

export default script